import { userConstants } from "../constants/user.constants";

// let user = JSON.parse(localStorage.getItem('user'));
const initialState = { loggedIn: false, user: {} };

export function authentication(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        loggingIn: true,
        user: action.user,
      };
    case userConstants.LOGIN_SUCCESS:
      const authState = {
        loggedIn: true,
        user: action.user,
        jwt: action.user.token,
      };
      return authState;
    case userConstants.LOGIN_FAILURE:
      return {};
    case userConstants.COOKIE_LOGIN_REQUEST:
      return {
        loggingIn: true,
        user: action.user,
      };
    case userConstants.COOKIE_LOGIN_SUCCESS:
      return {
        loggedIn: true,
        user: action.user,
        jwt: action.user.token,
      };
    case userConstants.COOKIE_LOGIN_FAILURE:
      return {};
    case userConstants.LOGOUT:
      return initialState;
    case userConstants.TOKEN_REFRESH:
      return Object.assign({}, state, { jwt: action.token });
    default:
      return state;
  }
}
